import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { type SidebarSublink, routes, useDataTracking } from '@cloud/shared';

export function useSidebarAnalytics(linksIdMapping: Map<string, SidebarSublink>) {
    const { pathname } = useLocation();
    const trackEvent = useDataTracking();

    useEffect(() => {
        trackEvent({
            event: 'pageview',
            page_url: pathname,
        });
    }, [trackEvent, pathname]);

    const handleMainMenu = (itemGtmId: string) => {
        trackEvent({
            event: 'main_navigation',
            menu_item: itemGtmId,
        });
    };

    const handleSubMenu = (itemId: string) => {
        const sidebarMenu = linksIdMapping.get(itemId);

        // skip sub-menu events for invalid links or if link has an icon,
        // meaning this is top-level menu parent, which is handled by `handleMainMenu` fn.
        if (!sidebarMenu || !sidebarMenu.to || 'icon' in sidebarMenu) {
            return;
        }

        trackEvent({
            event: 'sub_navigation',
            menu_item: sidebarMenu.gtmId,
        });

        if (itemId === routes.wizard.restart) {
            trackEvent({
                event: 'restart_onboarding',
            });
        }
    };

    return {
        handleMainMenu,
        handleSubMenu,
    };
}
